var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Box, lighten, darken } from '@mui/material';
import { styled } from '@mui/material/styles';
export var InsDel = function (props) { return _jsx(Root, __assign({}, props)); };
var Root = styled(Box, {
    name: 'RaInsDel',
    overridesResolver: function (props, styles) { return styles.root; },
})(function (_a) {
    var theme = _a.theme;
    return ({
        '& ins': {
            backgroundColor: theme.palette.mode === 'dark'
                ? darken(theme.palette.success.light, 0.7)
                : lighten(theme.palette.success.light, 0.7),
            color: theme.palette.mode === 'dark'
                ? lighten(theme.palette.success.light, 0.5)
                : darken(theme.palette.success.light, 0.5),
            textDecoration: 'none',
        },
        '& del': {
            backgroundColor: theme.palette.mode === 'dark'
                ? darken(theme.palette.error.light, 0.7)
                : lighten(theme.palette.error.light, 0.7),
            color: theme.palette.mode === 'dark'
                ? lighten(theme.palette.error.dark, 0.5)
                : darken(theme.palette.error.dark, 0.5),
            textDecoration: 'none',
        },
    });
});
